import React from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Icon, Step } from "semantic-ui-react";
import Job from "../../../models/Job";

const JobStatus = props => {
  const { job, showOnlyWhenRunning, title, currentStatusOnly, t } = props;
  if (showOnlyWhenRunning && !job.isRunning) return <></>;
  if (currentStatusOnly) {
    return (
      <>
        <Step.Group>
          <Step>
            {job.isRunning && <Icon loading name="spinner" />}
            <Step.Content>
              <Step.Title>{title}</Step.Title>
              <Step.Description>{Job.STATUS_DESCRIPTION[job.status]}</Step.Description>
            </Step.Content>
          </Step>
        </Step.Group>
      </>
    );
  }
  return (
    <>
      <Step.Group fluid widths={3}>
        <Step completed={job.status !== Job.STATUS.QUEUED} active={job.status === Job.STATUS.QUEUED}>
          <Icon name="wait" />
          <Step.Content>
            <Step.Title>{t("inQueue")}</Step.Title>
            <Step.Description>{t("jobInQueue")}</Step.Description>
          </Step.Content>
        </Step>

        <Step
          completed={[Job.STATUS.COMPLETED, Job.STATUS.FAILED, Job.STATUS.UNQUEUED].includes(job.status)}
          active={[Job.STATUS.WAIT_ASYNC, Job.STATUS.RUNNING].includes(job.status)}
          disabled={job.status === Job.STATUS.QUEUED}
        >
          <Icon loading={[Job.STATUS.WAIT_ASYNC, Job.STATUS.RUNNING].includes(job.status)} name="sync" />
          <Step.Content>
            <Step.Title>{t("inProgress")}</Step.Title>
            <Step.Description>{t("jobInProgress")}</Step.Description>
          </Step.Content>
        </Step>
        <Step
          completed={Job.STATUS.COMPLETED === job.status}
          active={[Job.STATUS.FAILED, Job.STATUS.UNQUEUED].includes(job.status)}
          disabled={![Job.STATUS.COMPLETED, Job.STATUS.FAILED, Job.STATUS.UNQUEUED].includes(job.status)}
        >
          {job.status === Job.STATUS.FAILED ? <Icon name="close" /> : <Icon name="check" />}
          <Step.Content>
            <Step.Title>
              {job.status === Job.STATUS.FAILED || job.status === Job.STATUS.UNQUEUED ? (
                <>{t("error")}</>
              ) : (
                <>{t("completed")}</>
              )}
            </Step.Title>
            <Step.Description>
              {job.status === Job.STATUS.FAILED || job.status === Job.STATUS.UNQUEUED ? (
                <>{t("thereWasError")}</>
              ) : (
                <>{t("jobProcessedSuccessfully")}</>
              )}
            </Step.Description>
          </Step.Content>
        </Step>
      </Step.Group>
    </>
  );
};
JobStatus.propTypes = {
  job: PropTypes.instanceOf(Job),
  title: PropTypes.string,
  currentStatusOnly: PropTypes.bool,
  showOnlyWhenRunning: PropTypes.bool,
  t: PropTypes.func.isRequired,
};
JobStatus.defaultTypes = {
  showOnlyWhenRunning: false,
  currentStatusOnly: true,
};

export default withTranslation()(observer(JobStatus));
